import { createSelector } from '@reduxjs/toolkit';
import { personalDataItemsForMap } from './personal-data-items-for-map';
import { personalDataItemsInComputers } from './personal-data-items-in-computers';

export const offlinePersonalDataItems = createSelector(personalDataItemsForMap, (personalDataItems) => {
  return personalDataItemsInComputers(personalDataItems, '');
});
